import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zStateReqAttributes = z.object({
  stateId: zUid,
  attributeIds: zUid.array(),
});
export type ZStateReqAttributes = z.infer<typeof zStateReqAttributes>;
